@let showError = ngControl.invalid && isSubmitted();
<div class="d-flex flex-column gap-1">
  <lib-checkbox
    [selected]="selected()"
    [disabled]="disabled()"
    [indeterminate]="indeterminate()"
    [size]="size()"
    (checkboxClick)="checkboxClick()">
    {{ label() }}
  </lib-checkbox>
  @if (showError) {
    <lib-form-error [errors]="ngControl.errors"></lib-form-error>
  }
</div>
